import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { UpdateDriversScheduleComponent } from './update-drivers-schedule.component';
import { UpdateDriversScheduleService } from './update-drivers-schedule.service';
import { InputTimeModule } from '../input-time/input-time.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MyDateRangePickerModule,
    TextMaskModule,
    InputTimeModule
  ],
  declarations: [UpdateDriversScheduleComponent],
  exports: [UpdateDriversScheduleComponent],
  providers: [UpdateDriversScheduleService]
})
export class UpdateDriversScheduleModule { }



// WEBPACK FOOTER //
// ./src/app/utils/update-drivers-schedule/update-drivers-schedule.module.ts